import { useEffect, useRef } from "react";
import {
  ShoppingBag, Truck, Globe, Clock
} from "lucide-react";

const services = [
  {
    title: "In-Store Shopping",
    icon: ShoppingBag,
    desc: "Browse our full range of products with the help of our friendly staff.",
    color: "text-teal-600",
    bg: "bg-teal-50",
    size: "",
  },
  {
    title: "Prescription Delivery",
    icon: Truck,
    desc: "Free home delivery straight to your doorstep.",
    color: "text-blue-600",
    bg: "bg-blue-50",
    size: "",
  },
  {
    title: "Language Assistance",
    icon: Globe,
    desc: "We speak English, Spanish, and Haitian Creole to serve our diverse community.",
    color: "text-teal-600",
    bg: "bg-teal-50",
    size: "",
  },
  {
    title: "Quick Visit Options",
    icon: Clock,
    desc: "Minimal wait times so you can get back to what matters.",
    color: "text-blue-600",
    bg: "bg-blue-50",
    size: "",
  },
];

export default function Services() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const items = ref.current?.querySelectorAll(".animate-on-view");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" data-testid="services-section" className="ez-section bg-ez-blue-light" ref={ref}>
      <div className="ez-container">
        <div className="animate-on-view text-center mb-16">
          <div className="inline-block text-ez-teal font-semibold font-caveat text-lg mb-3">
            How We Help
          </div>
          <h2 className="font-outfit text-2xl md:text-3xl font-bold text-ez-text">
            Our <span className="text-ez-teal">Services</span>
          </h2>
          <p className="text-ez-muted mt-4 max-w-xl mx-auto font-jakarta">
            Convenient, accessible, and always designed with your health in mind.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                data-testid={`service-card-${i}`}
                className="animate-on-view ez-card p-8 flex flex-col gap-4 group"
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <div className={`w-14 h-14 ${service.bg} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <Icon size={26} className={service.color} strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-outfit font-bold text-ez-text text-lg mb-2">{service.title}</h3>
                  <p className="text-ez-muted text-sm font-jakarta leading-relaxed">{service.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
